
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getPostById, BlogPost as BlogPostType } from '@/services/blogService';
import BlogPostLayout from '@/components/blog/BlogPostLayout';
import BlogPostView from '@/components/blog/BlogPostView';
import { LoadingState, NotFoundState } from '@/components/blog/BlogPostStates';

const BlogPost = () => {
  const { id } = useParams<{ id: string }>();
  const [post, setPost] = useState<BlogPostType | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (id) {
        const postId = parseInt(id, 10);
        const foundPost = getPostById(postId);
        setPost(foundPost);
      }
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [id]);

  if (isLoading) {
    return (
      <BlogPostLayout isLoading={true}>
        <LoadingState />
      </BlogPostLayout>
    );
  }

  if (!post) {
    return (
      <BlogPostLayout notFound={true}>
        <NotFoundState />
      </BlogPostLayout>
    );
  }

  return (
    <BlogPostLayout>
      <BlogPostView post={post} />
    </BlogPostLayout>
  );
};

export default BlogPost;
